import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import Slider from 'react-slick';

import { media, rem, themed } from '@/shared/ui/core';

const modifiers = {
  woArrows: () => ({
    styles: `
      .slick-arrow {
        display: none !important;
      }
    `,
  }),
  error: () => ({
    styles: `
      margin-top: .85rem;
    `,
  }),
};

export const CarouselStyled = styled(Slider)`
  box-sizing: border-box;
  display: block;
  position: relative;
  user-select: none;
  touch-action: pan-y;

  .slick-list {
    margin: 0;
    padding: 0;
    display: block;
    position: relative;
    overflow: hidden;
  }

  .slick-list:focus {
    outline: none;
  }

  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-track,
  .slick-list {
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    display: block;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    top: 0;
    left: 0;
  }

  .slick-track:before,
  .slick-track:after {
    content: "";
    display: table;
  }

  .slick-track:after {
    clear: both;
  }
  .slick-loading .slick-track {
    visibility: hidden;
  }
  .slick-slide {
    height: 100%;
    min-height: 1px;
    display: none;
    float: left;
    outline: none;
    padding: .25rem;
  }

  [dir="rtl"] .slick-slide {
    float: right;
  }

  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  &.slick-initialized .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    height: auto;
    border: 1px solid transparent;
    display: block;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }

  /* Petco UI */

  .slick-dots {
    width: 100%;
    padding: 0;
    margin-top: ${rem(16)};
    display: flex !important;
    justify-content: center;
    align-items: center;

    li {
      list-style: none;

      button {
        text-indent: -9999px;
        background-color: #e5e5e5;
        width: ${rem(10)};
        height: ${rem(10)};
        padding: 0;
        margin: auto;
        border: none;
        border-radius: 50%;
        display: inline-block;
        outline: 0;
        overflow: hidden;
        cursor: pointer;
        @media ${media.tabletMax} {
          width: ${rem(15)};
          height: ${rem(15)};
        }
      }

      &.slick-active button {
        box-sizing: content-box;
        background-color: ${themed('primary.accent')};
        border: solid ${themed('primary.accent')} 0.0625rem;
      }

      & + li {
        margin-left: ${rem(20)};
      }
    }
  }
  ${applyStyleModifiers(modifiers)};
`;
